export const MoneySvg = () => {
  return (
    <svg
      width='39'
      height='39'
      viewBox='0 0 39 39'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2134_3445)'>
        <path
          d='M21.1961 26.2827H16.957V39.0001H21.1961V26.2827Z'
          fill='#273BCD'
        />
        <path
          d='M38.5753 26.2827H23.7383V28.8262H38.5753V26.2827Z'
          fill='#273BCD'
        />
        <path
          d='M38.5753 31.3696H23.7383V33.9131H38.5753V31.3696Z'
          fill='#273BCD'
        />
        <path
          d='M23.7383 36.4566V39.0001H37.3035C38.0058 39.0001 38.5753 38.4307 38.5753 37.7283V36.4565H23.7383V36.4566Z'
          fill='#273BCD'
        />
        <path
          d='M0.423828 36.4565V37.7283C0.423828 38.4306 0.993213 39.0001 1.69559 39.0001H14.413V36.4566L0.423828 36.4565Z'
          fill='#273BCD'
        />
        <path
          d='M14.4129 31.3696H0.423828V33.9131H14.4129V31.3696Z'
          fill='#273BCD'
        />
        <path
          d='M14.4129 26.2827H0.423828V28.8262H14.4129V26.2827Z'
          fill='#273BCD'
        />
        <path
          d='M37.3043 0H1.69559C0.993518 0 0.423828 0.569232 0.423828 1.27177V22.4674C0.423828 23.17 0.993518 23.7392 1.69559 23.7392H37.3043C38.0064 23.7392 38.576 23.17 38.576 22.4674V1.27177C38.576 0.569232 38.0064 0 37.3043 0ZM14.4129 7.63044H10.38C9.99582 8.713 9.13644 9.57237 8.05427 9.9562V12.9352C9.13644 13.319 9.99582 14.1784 10.38 15.261H14.4129V17.8044H9.32596C8.62388 17.8044 8.05419 17.2352 8.05419 16.5326C8.05419 15.8314 7.48367 15.2609 6.78243 15.2609C6.08035 15.2609 5.51066 14.6916 5.51066 13.9891V8.90213C5.51066 8.1996 6.08035 7.63036 6.78243 7.63036C7.48367 7.63036 8.05419 7.05984 8.05419 6.3586C8.05419 5.65607 8.62388 5.08683 9.32596 5.08683H14.4129V7.63044ZM21.1956 21.1957H16.9565V2.54345H21.1956V21.1957ZM33.4891 13.9891C33.4891 14.6916 32.9194 15.2609 32.2173 15.2609C31.516 15.2609 30.9455 15.8314 30.9455 16.5326C30.9455 17.2352 30.3758 17.8044 29.6738 17.8044H23.739V15.261H28.6198C29.0039 14.1784 29.8633 13.319 30.9455 12.9352V9.9562C29.8633 9.57244 29.004 8.713 28.6198 7.63044H23.739V5.08706H29.6738C30.3758 5.08706 30.9455 5.6563 30.9455 6.35883C30.9455 7.06007 31.516 7.63059 32.2173 7.63059C32.9194 7.63059 33.4891 8.19983 33.4891 8.90236V13.9891Z'
          fill='#273BCD'
        />
      </g>
      <defs>
        <clipPath id='clip0_2134_3445'>
          <rect width='39' height='39' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
